import { GetCountriesData } from '@shared/interfaces/api.interfaces';
import { LatinLettersTooltip } from '../components/addresses/city-select-international/city-select.constants';
import { CountryRecipientPayerConfig, DefaultCountryPhoneConfig } from '../international-invoice.constants';

// France
export const FR: Partial<GetCountriesData> = {
  ...DefaultCountryPhoneConfig,
  ...CountryRecipientPayerConfig,
  CityTooltip: LatinLettersTooltip,
  RecipientSpotSelectionAvailable: true,
  RecipientRegistrationAddressRequired: true,
  AllowedWarehouseOwners: ['NPAX'],
  RecipientPayerAllowed: true,
};
